import {svgIconWrapper} from '../svg-icon-wrapper';

import CommentSmileRegular from './comment-smile-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CommentSmileRegular {...validProps} />;
}

SvgComponent.iconName = 'comment-smile-regular';

export const CommentSmileRegularIcon = svgIconWrapper(SvgComponent);
